import { render } from "./OutputArea.vue?vue&type=template&id=04eb8a63"
import script from "./OutputArea.vue?vue&type=script&lang=js"
export * from "./OutputArea.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__